export default __webpack_public_path__ + "static/media/banner-consumption-comp.2c1885f1.jpg";